import { Row, Col } from 'react-bootstrap';
import { Input } from './Input/Input';
import { numberWithCommas } from '../utils/format';

const RenderTotalColumn = ({ field, label, value, className = '' }) => {
  return field !== undefined ? (
    <Col>
      <Input disabled label={label} value={value} classNameInputField={className} />
    </Col>
  ) : null;
};

function GridTotals({
  totalGrossMassLabel,
  grossKG,
  totalNetMassLabel,
  netKG,
  itemCount,
  totalValueLabel,
  value,
  totalPackageCountLabel,
  itemRowsCount,
  rows,
  totalStatValueLabel,
  totalStatValue,
  totalDutyLabel,
  totalDuty,
  totalVATLabel,
  totalVAT,
  packagesCount,
  additionalStyles,
  billableType,
  itemHeaders,
  other = [],
}) {
  const grossKGformatted = numberWithCommas(grossKG, true);
  const netKGformatted = numberWithCommas(netKG, true);
  const itemCountformatted = numberWithCommas(itemCount, false);
  const packagesCountformatted = numberWithCommas(packagesCount, false);
  const valueFormatted = numberWithCommas(value, true);
  const totalStatValueFormatted = numberWithCommas(totalStatValue, true);
  const totalDutyFormatted = numberWithCommas(totalDuty, true);
  const totalVATFormatted = numberWithCommas(totalVAT, true);

  return (
    <div className="d-flex flex-column" style={additionalStyles}>
      <Row>
        {/* PLEASE NOTE: itemRowsCount & rows show the same value but this is how to control the order in which fields are shown on the screen,
                        as GridTotals is a component used across the CABIE application. */}
        {other.map((item, index) => {
          return <Col key={index}>{item}</Col>;
        })}
        <RenderTotalColumn
          field={itemRowsCount}
          label={`${totalPackageCountLabel ? totalPackageCountLabel : 'Item Rows'}`}
          value={itemRowsCount}
        />
        <RenderTotalColumn field={packagesCount} label="Packages" value={packagesCountformatted} />
        <RenderTotalColumn field={grossKG} label="Gross Mass (kg)" value={grossKGformatted} />
        <RenderTotalColumn field={netKG} label="Net Mass (kg)" value={netKGformatted} />
        <RenderTotalColumn field={itemCount} label="Number of Packages" value={itemCountformatted} />
        <RenderTotalColumn
          field={value}
          label={`${totalValueLabel ? totalValueLabel : 'Value'}`}
          value={valueFormatted}
        />
        <RenderTotalColumn
          field={totalStatValue}
          label={`${totalStatValueLabel ? totalStatValueLabel : 'Stat Value'}`}
          value={totalStatValueFormatted}
        />

        <RenderTotalColumn
          field={totalDuty}
          label={`${totalDutyLabel ? totalDutyLabel : 'Total Duty'}`}
          value={totalDutyFormatted}
        />
        <RenderTotalColumn
          field={totalVAT}
          label={`${totalVATLabel ? totalVATLabel : 'Total VAT'}`}
          value={totalVATFormatted}
        />
        <RenderTotalColumn
          field={rows}
          label="Item Rows"
          value={rows}
          className={billableType == 20 && 'billable-type-textbox'}
        />
        <RenderTotalColumn
          field={itemHeaders}
          label="Item Headers"
          value={itemHeaders}
          className={billableType == 10 && 'billable-type-textbox'}
        />
      </Row>
    </div>
  );
}

export default GridTotals;
